import React, { useRef, useState, useEffect } from 'react';
import { useLang } from '../LangContext';

export default function ContactModal({ open, onClose }) {
  const { t } = useLang();
  const m = t.modal;
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // null | 'success' | 'error'
  const [countdown, setCountdown] = useState(10);
  const [projectType, setProjectType] = useState('');

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) {
      const timer = setTimeout(() => setStatus(null), 350);
      return () => clearTimeout(timer);
    }
  }, [open]);

  useEffect(() => {
    if (status !== 'success') return;
    setCountdown(10);
    const interval = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) { clearInterval(interval); onClose(); return 0; }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [status, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const data = new FormData(formRef.current);
      data.append('access_key', 'e98f9025-3453-44d6-a3d6-cef61c095cc0');
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: data,
      });
      const json = await res.json();
      if (json.success) {
        setStatus('success');
        formRef.current?.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={`cmodal${open ? ' cmodal--open' : ''}`} onMouseDown={onClose}>
      <div className="cmodal__box" onMouseDown={(e) => e.stopPropagation()}>

        <div className="cmodal__head">
          <div>
            <span className="cmodal__label">{m.heading}</span>
            <p className="cmodal__sub">{m.sub}</p>
          </div>
          <button className="cmodal__esc" onClick={onClose}>ESC</button>
        </div>

        {status === 'success' ? (
          <div className="cmodal__success">
            <div className="cmodal__check">✓</div>
            <div className="cmodal__success-title">{m.successTitle}</div>
            <p className="cmodal__success-sub">{m.successSub}</p>
            <div className="cmodal__countdown">
              <div className="cmodal__countdown-bar" style={{ animationDuration: '10s' }} />
              <span className="cmodal__countdown-label">{m.countdown(countdown)}</span>
            </div>
          </div>
        ) : (
          <form ref={formRef} className="cmodal__form" onSubmit={handleSubmit} noValidate>
            <input
              type="hidden"
              name="subject"
              value={projectType ? `Nouveau projet — ${projectType} · Portfolio` : 'Nouveau message — Portfolio TRAORE Lamine'}
            />

            <div className="cmodal__row">
              <div className="cmodal__field">
                <label className="cmodal__lbl">{m.labelName}</label>
                <input
                  className="cmodal__input"
                  type="text"
                  name="name"
                  required
                  placeholder={m.phName}
                  autoComplete="name"
                />
              </div>
              <div className="cmodal__field">
                <label className="cmodal__lbl">{m.labelEmail}</label>
                <input
                  className="cmodal__input"
                  type="email"
                  name="email"
                  required
                  placeholder={m.phEmail}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="cmodal__field">
              <label className="cmodal__lbl">{m.labelType}</label>
              <select
                className="cmodal__input cmodal__select"
                name="project_type"
                value={projectType}
                onChange={(e) => setProjectType(e.target.value)}
              >
                <option value="">{m.phType}</option>
                {m.projectTypes.map((pt) => (
                  <option key={pt.value} value={pt.value}>{pt.label}</option>
                ))}
              </select>
            </div>

            <div className="cmodal__field">
              <label className="cmodal__lbl">{m.labelMsg}</label>
              <textarea
                className="cmodal__input cmodal__textarea"
                name="message"
                required
                placeholder={m.phMsg}
                rows={5}
              />
            </div>

            {status === 'error' && (
              <div className="cmodal__error">
                {m.errorText}{' '}
                <a href="mailto:lahminet0@gmail.com">lahminet0@gmail.com</a>
              </div>
            )}

            <div className="cmodal__footer">
              <span className="cmodal__hint">{m.hint}</span>
              <button type="submit" className="cmodal__btn" disabled={sending}>
                {sending ? (
                  <><span className="cmodal__spinner" /> {m.sending}</>
                ) : (
                  m.send
                )}
              </button>
            </div>

          </form>
        )}

      </div>
    </div>
  );
}
